import { AssetTypes } from "../backend/types/utils";
import { getStorageCurrentCreatedInvestment, getStorageCurrentInvestment, getStorageCurrentSales, getStorageInvestments, getStorageLanguage, getStoragePersonalDetails, getStorageToken } from "../utils/localStorage";
import { CreateInvestmentManageable, InvestmentManageable } from "./investment/types";
import { SaleManageable } from "./sale/types";
import { UserManageable } from "./user/types";

export type ID = string;

export interface StoreState {
  sales: Map<AssetTypes, Array<SaleManageable>>;
  currentUser: UserManageable;
  token: string;
  currentInvestment: InvestmentManageable | null;
  currentCreatedInvestment: CreateInvestmentManageable | null;
  investments: Array<InvestmentManageable>;
  language: string;
}

export const initialState: StoreState = {
  sales: getStorageCurrentSales(),
  currentUser: getStoragePersonalDetails(),
  token: getStorageToken(),
  currentInvestment: getStorageCurrentInvestment(),
  currentCreatedInvestment: getStorageCurrentCreatedInvestment(),
  investments: getStorageInvestments(),
  language: getStorageLanguage(),
};
